import { SafeLogErrorOptions } from '../log-error';
import { BaseError } from './BaseError';

export class BridgeChannelError extends BaseError {
    constructor(message: string, type: string, loggerFields: SafeLogErrorOptions, stack?: string) {
        super(
            message,
            {
                source: 'backend',
                block: 'bridge-channel',
                ...loggerFields,
                additional: {
                    ...loggerFields?.additional,
                    bridgeType: type,
                },
            },
            stack
        );

        Object.setPrototypeOf(this, BridgeChannelError.prototype);
    }
}
